import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../components/WebView/icons/Trashcan.svg'


const _withScopeId = n => (_pushScopeId("data-v-947e7be0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-card-body" }
const _hoisted_2 = { class: "dialog-card-title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Delete this suggestion"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "subtitle"
}
const _hoisted_6 = { class: "created" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActionLabel = _resolveComponent("ActionLabel")!
  const _component_TextWithHighlight = _resolveComponent("TextWithHighlight")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('openDetails')))
      }, _toDisplayString(_ctx.title), 1),
      (_ctx.canDelete)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "image-btn delete-btn",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onDelete && _ctx.onDelete(...args)))
          }, _hoisted_4))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('openDetails')))
    }, [
      (_ctx.subtitle)
        ? (_openBlock(), _createElementBlock("h5", _hoisted_5, _toDisplayString(_ctx.subtitle), 1))
        : _createCommentVNode("", true),
      (_ctx.action && _ctx.type === 'comment')
        ? (_openBlock(), _createBlock(_component_ActionLabel, {
            key: 1,
            action: _ctx.action
          }, null, 8, ["action"]))
        : _createCommentVNode("", true),
      _createVNode(_component_TextWithHighlight, {
        class: "body",
        text: _ctx.body,
        highlights: _ctx.highlights
      }, null, 8, ["text", "highlights"]),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.formatTime(_ctx.created)), 1)
    ])
  ]))
}